export const salutations = [
  { id: "Mr", name: "Mr" },
  { id: "Mrs", name: "Mrs" },
  { id: "Ms", name: "Ms" },
  { id: "Miss", name: "Miss" },
  { id: "Mdm", name: "Mdm" },
  { id: "Dr", name: "Dr" },
];
